export const limitBookNameLength = (str) => {
  const specialCharacters = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  let limit = 25;

  if (specialCharacters.test(str)) {
    limit = 23;
  }

  return str.length > limit ? `${str.substring(0, limit)}...` : str;
};

export const transform = (items, take = 10) => {
  const grouped = new Map();
  const order = new Map();

  items.forEach(({ title, link, library }, index) => {
    if (!grouped.has(title)) {
      grouped.set(title, []);
      order.set(title, index);
    }
    grouped.get(title).push({ name: library, link });
  });

  const sortedTitles = [...grouped.keys()].sort((a, b) => {
    const lenDiff = grouped.get(b).length - grouped.get(a).length;
    if (lenDiff !== 0) return lenDiff;
    return order.get(a) - order.get(b);
  });

  const selected = sortedTitles.slice(0, take);

  return selected.map((title) => ({
    title,
    libraries: grouped.get(title),
  }));
};
